import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, TrendingUp, Users, BookOpen } from "lucide-react";

export default function StartHere() {
  const bookingUrl = "https://academy.suhasinibasa.com/web/checkout/6a8eb2e3570da12b73781f39";

  const paths = [
    {
      idx: "01",
      title: "I want to grow my career",
      desc: "Analyze our structured curriculum offerings from quickstart checklists to deep cohort certifications.",
      icon: <TrendingUp className="w-6 h-6 text-gold" />,
      cta: "Explore Programs",
      link: "/programs",
      isExternal: false,
      testId: "start-here-pathway-programs"
    },
    {
      idx: "02",
      title: "I need personalized guidance",
      desc: "Align your unique professional objectives, internal politics, and stakeholder communications directly in a private consultation.",
      icon: <Users className="w-6 h-6 text-gold" />,
      cta: "Book 1:1 Consultation",
      link: bookingUrl,
      isExternal: true,
      testId: "start-here-pathway-coaching"
    },
    {
      idx: "03",
      title: "I want to learn first",
      desc: "Access our practical free templates, communication scripts, and 30-day organizational visibility roadmaps.",
      icon: <BookOpen className="w-6 h-6 text-gold" />,
      cta: "Get Free Resources",
      link: "/free-resources",
      isExternal: false,
      testId: "start-here-pathway-resources"
    }
  ];

  return (
    <div className="relative bg-obsidian text-slate-100 min-h-screen flex flex-col justify-center py-20 lg:py-32 px-4 sm:px-6 lg:px-12">
      <div className="noise-overlay" />
      
      {/* Background accents */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-5xl mx-auto w-full relative z-10 space-y-12">
        <div className="text-center space-y-4 max-w-3xl mx-auto">
          <span className="text-xs uppercase tracking-[0.25em] text-gold font-mono font-bold">CHOOSE YOUR PATHWAY</span>
          <h1 className="font-display text-3xl sm:text-5xl font-bold tracking-tight text-white leading-tight">
            How would you like to build your leverage?
          </h1>
          <p className="text-slate-400 text-sm sm:text-base max-w-xl mx-auto">
            Choose the logical next action block that matches your current career checkpoint and professional goals.
          </p>
        </div>

        {/* 3 Pathway Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {paths.map((path) => (
            <div 
              key={path.idx}
              className="bg-navy border border-white/5 p-8 flex flex-col justify-between hover:border-gold/35 hover:scale-[1.02] transition-all duration-300 min-h-[340px]"
            >
              <div className="space-y-6 text-left">
                <div className="flex justify-between items-center">
                  <span className="font-mono text-xs text-gold font-bold">PATH {path.idx}</span>
                  {path.icon}
                </div>
                <h3 className="font-display text-xl font-bold text-white leading-snug">{path.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{path.desc}</p>
              </div>

              <div className="pt-8">
                {path.isExternal ? (
                  <a
                    href={path.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={path.testId}
                    className="w-full bg-gold hover:bg-gold-hover text-obsidian py-3 font-display font-bold text-xs uppercase tracking-widest block text-center transition-colors duration-200"
                  >
                    {path.cta}
                  </a>
                ) : (
                  <Link
                    to={path.link}
                    data-testid={path.testId}
                    className="w-full bg-gold hover:bg-gold-hover text-obsidian py-3 font-display font-bold text-xs uppercase tracking-widest block text-center transition-colors duration-200"
                  >
                    {path.cta}
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
